import { Toaster } from "react-hot-toast";
import './App.css';
import MachCity from './Components/MachCity/MachCity';

function App() {
  return (
    <div>
      <MachCity />
      <Toaster />
    </div>
  );
}

export default App;
